export default "__VITE_ASSET__3032e768__"